<mat-dialog-actions align="end">
    <div>
        <button id="x" (click)="onNoClick()">
        X
    </button>
    </div>
</mat-dialog-actions>
<ngb-carousel id="myCarousel">
    <ng-template ngbSlide *ngFor="let image of dataImage">
        <div class="carousel-items" style="max-width: 756px; max-height: 425px;">
            <img class="" src="https://ros.com.sg/demo/rosapi/{{image.engg_image}}" alt="" width="100%;">
        </div>
    </ng-template>
</ngb-carousel>